import React from "react";
import "./BaseCard.css";

/**
 * BaseCard
 * Reusable, modern card container with consistent radius, shadow, and spacing.
 *
 * Props:
 * - title?: string | ReactNode
 * - subtitle?: string | ReactNode
 * - headerRight?: ReactNode
 * - footer?: ReactNode
 * - className?: string
 * - clickable?: boolean
 * - onClick?: () => void
 */
function BaseCard({
  title,
  subtitle,
  headerRight,
  footer,
  className = "",
  clickable = false,
  children,
  onClick,
  ...rest
}) {
  const role = clickable && onClick ? "button" : undefined;

  return (
    <div
      className={`card base-card ${clickable ? "clickable" : ""} ${className}`}
      onClick={onClick}
      role={role}
      {...rest}
    >
      {(title || headerRight) && (
        <div className="base-card-header">
          <div>
            {title && <h3 className="base-card-title">{title}</h3>}
            {subtitle && (
              <p className="base-card-subtitle">{subtitle}</p>
            )}
          </div>
          {headerRight && (
            <div className="base-card-header-right">{headerRight}</div>
          )}
        </div>
      )}

      <div className="base-card-body">{children}</div>

      {footer && <div className="base-card-footer">{footer}</div>}
    </div>
  );
}

export default BaseCard;

